import React from 'react';

/**
 * Terms & Conditions body for the order detail widget.
 *
 * Visibility is controlled solely by the widget settings toggle
 * (`ORDER_WIDGET_IDS.TERMS_AND_CONDITION`) in OrderDetailsWidgets, which also
 * owns the surrounding CardCmp. This component previously also gated itself on
 * `currentUser.appearanceData.generalConditionsEnglish` being non-empty, which
 * left an empty Terms card for orgs that never filled in that appearance field —
 * even though the terms text below is fully hardcoded and never read from
 * appearanceData. The gate was removed rather than wired up so that "enabled in
 * Widgets settings" is the single source of truth.
 */
const TermsAndConditions: React.FC = () => (
    <div className="px-3 py-3 space-y-3">
        <div className="flex flex-col">
            <span className="text-[12px] leading-[18px] font-semibold text-textSecondary">Appointments:</span>
            <span className="text-[12px] leading-[18px] font-normal text-grayLight600">May be subject to a surcharge.</span>
        </div>
        <div className="flex flex-col">
            <span className="text-[12px] leading-[18px] font-semibold text-textSecondary">Loss or Damage Claims:</span>
            <span className="text-[12px] leading-[18px] font-normal text-grayLight600">Carrier liability is limited to a maximum of $2.00 CAD per pound.</span>
        </div>
        <div className="flex flex-col">
            <span className="text-[12px] leading-[18px] font-semibold text-textSecondary">Currency:</span>
            <span className="text-[12px] leading-[18px] font-normal text-grayLight600">
                Rates are quoted in the currency specified above. If no currency is indicated, all amounts are in Canadian Dollars (CAD).
            </span>
        </div>
        <div className="flex flex-col">
            <span className="text-[12px] leading-[18px] font-semibold text-textSecondary">Discrepancies:</span>
            <span className="text-[12px] leading-[18px] font-normal text-grayLight600">
                Rates are subject to adjustment if the actual weight, dimensions, or quantities differ from the original information provided.
            </span>
        </div>
        <div className="flex flex-col gap-1">
            <span className="text-[12px] leading-[18px] font-semibold text-textSecondary">Waiting Time:</span>
            <div className="flex flex-col gap-0.5">
                <span className="text-[12px] leading-[18px] font-semibold text-grayLight600">FTL (Full Truckload):</span>
                <ul className="list-disc pl-4">
                    <li className="text-[12px] leading-[18px] font-normal text-grayLight600">2 hours free for loading/unloading</li>
                </ul>
            </div>
            <div className="flex flex-col gap-0.5">
                <span className="text-[12px] leading-[18px] font-semibold text-grayLight600">LTL (Less Than Truckload):</span>
                <ul className="list-disc pl-4">
                    <li className="text-[12px] leading-[18px] font-normal text-grayLight600">1 hour free for shipments over 4 skids</li>
                    <li className="text-[12px] leading-[18px] font-normal text-grayLight600">30 minutes free for shipments under 4 skids</li>
                    <li className="text-[12px] leading-[18px] font-normal text-grayLight600">Additional waiting time will be subject to a surcharge.</li>
                </ul>
            </div>
        </div>
        <div className="flex flex-col">
            <span className="text-[12px] leading-[18px] font-semibold text-textSecondary">Cancellations:</span>
            <span className="text-[12px] leading-[18px] font-normal text-grayLight600">Cancellations made within 24 hours of the scheduled pickup date may be subject to a cancellation fee.</span>
        </div>
        <div className="flex flex-col">
            <span className="text-[12px] leading-[18px] font-semibold text-textSecondary">LTL Shipments:</span>
            <span className="text-[12px] leading-[18px] font-normal text-grayLight600">Estimated delivery dates for LTL shipments are based on standard transit times and are subject to change.</span>
        </div>
    </div>
);

export default TermsAndConditions;
